import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

// Components
import { MenuList } from './MenuList';
import { BurgerButton } from 'shared/components/ui/BurgerButton';

// Hooks and stores
import { useTabletAndBelowMediaQuery } from 'shared/store/responsiveStore';
import colorsStore from 'shared/store/colorsStore';
import uiStore from 'shared/store/uiStore';
import useToggleMenu from './useToggleMenu';

// Styles
import styles from './AppMenu.module.scss';

export const AppMenu: React.FC = () => {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);
  const isTabletOrBelow = useTabletAndBelowMediaQuery();
  const menuVisible = uiStore((state) => state.menuVisible);
  const isMenuClosing = uiStore((state) => state.isMenuClosing);
  const { t } = useTranslation();

  const toggleMenu = useToggleMenu();

  // For desktop, render MenuList directly
  if (!isTabletOrBelow) {
    return <MenuList />;
  }

  // For tablet and below, render burger menu with conditional MenuList
  return (
    <>
      <div className={styles.fixedBurgerButtonContainer}>
        <BurgerButton
          color={colorsConfig.finecoBlack}
          size={36}
          onClick={toggleMenu}
          className={styles.hamburgerToggle}
          isSidebarOpen={menuVisible && !isMenuClosing}
        />
        {menuVisible && !isMenuClosing && <div className={styles.menuLabel}>{t('menu.close')}</div>}
      </div>

      {menuVisible && (
        <div
          className={classNames(styles.menuOverlay, {
            [styles.menuOverlayHidden]: isMenuClosing,
          })}
        >
          <div
            className={classNames(styles.menuPanel, {
              [styles.menuPanelHidden]: isMenuClosing,
            })}
          >
            <MenuList onClose={toggleMenu} isOpen={menuVisible && !isMenuClosing} />
          </div>
        </div>
      )}
    </>
  );
};
